import ServiceApi from "../ServiceApi";
export default class ServiceReconciliationMatch {
    static _microserviceName = "free";

    static _requestRouts = {
        getTableSimilarSides: '/match/similar-ap-sides',
        runMatch: '/match/map-toggle-matching',
        acceptDifference: '/match/accept-difference'
    };

    static _tableColumnsToMatchScheme = [
        {
            label: "Клиент",
            prop: "client",
            columnStyles: {
                width: "130px",
            },
        },
        {
            label: "Бренд",
            prop: "brand",
            columnStyles: {
                width: "130px",
            },
        },
        {
            label: "Город",
            prop: "city",
            columnStyles: {
                width: "130px",
            },
        },
        {
            label: "Сторона",
            prop: "side",
            columnStyles: {
                width: "80px",
            },
        },
        {
            label: "Адрес",
            prop: "address",
            columnStyles: {
                width: "500px",
            },
        },
        {
            label: "Оператор",
            prop: "supplier",
            columnStyles: {
                width: "110px",
            },
        },
        {
            label: "Тип",
            prop: "type",
            columnStyles: {
                width: "120px",
            },
        },
        {
            label: "Вид",
            prop: "kind",
            columnStyles: {
                width: "80px",
            },
        },
        {
            label: "Формат",
            prop: "format",
            columnStyles: {
                width: "80px",
            },
        },
        {
            label: "GID",
            prop: "gid",
            columnStyles: {
                width: "120px",
            },
        },
        {
            label: "Материал",
            prop: "material",
            columnStyles: {
                width: "120px",
            },
        },
        {
            label: "Дополнительное поле 1",
            prop: "ext_field_1",
            columnStyles: {
                width: "120px",
            },
        },
        {
            label: "Дополнительное поле 2",
            prop: "ext_field_2",
            columnStyles: {
                width: "120px",
            },
        },
        {
            label: "Дополнительное поле 3",
            prop: "ext_field_3",
            columnStyles: {
                width: "120px",
            },
        },
        {
            label: "Дополнительное поле 4",
            prop: "ext_field_4",
            columnStyles: {
                width: "120px",
            },
        },
        {
            label: "Дополнительное поле 5",
            prop: "ext_field_5",
            columnStyles: {
                width: "120px",
            },
        },
        {
            label: "Дополнительное поле 6",
            prop: "ext_field_6",
            columnStyles: {
                width: "120px",
            },
        },
        {
            label: "Дополнительное поле 7",
            prop: "ext_field_7",
            columnStyles: {
                width: "120px",
            },
        },
        {
            label: "Дополнительное поле 8",
            prop: "ext_field_8",
            columnStyles: {
                width: "120px",
            },
        },
        {
            label: "Дополнительное поле 9",
            prop: "ext_field_9",
            columnStyles: {
                width: "120px",
            },
        },
        {
            label: "Дополнительное поле 10",
            prop: "ext_field_10",
            columnStyles: {
                width: "120px",
            },
        },
        {
            label: "Доп поле размещения 1",
            prop: "additional_field_1",
            columnStyles: {
                width: "120px",
            },
        },
        {
            label: "Доп поле размещения 2",
            prop: "additional_field_2",
            columnStyles: {
                width: "120px",
            },
        },
        {
            label: "Доп поле размещения 3",
            prop: "additional_field_3",
            columnStyles: {
                width: "120px",
            },
        },
        {
            label: "Доп поле размещения 4",
            prop: "additional_field_4",
            columnStyles: {
                width: "120px",
            },
        },
        {
            label: "Доп поле размещения 5",
            prop: "additional_field_5",
            columnStyles: {
                width: "120px",
            },
        },
        {
            label: "Доп поле размещения 6",
            prop: "additional_field_6",
            columnStyles: {
                width: "120px",
            },
        },
        {
            label: "Сверено с предфактом",
            prop: "mapMatchStatus",
            isSlot: true,
            columnStyles: {
                width: "140px",
                padding: '0'
            },
            classes: ["map-match-status"],
        },
        {
            label: "Расстояние",
            prop: "distance",
            columnStyles: {
                width: "120px",
            },
        },
    ];

    static _tableRowToMatchScheme = {
        id: (row) => String(row?.price_id ?? ''),
        client: (row) => String(row?.entity_name ?? ''),
        brand: (row) => String(row?.brand_name ?? ''),
        city: (row) => String(row?.city?.name ?? ''),
        side: (row) => String(row?.code ?? ''),
        address: (row) => String(row?.info?.realAddress ?? ''),
        supplier: (row) => String(row?.properties?.supp_id ?? ''),
        type: (row) => String(row?.properties?.type_id ?? ''),
        kind: (row) => String(row?.properties?.kind_id ?? ''),
        format: (row) => String(row?.properties?.format_id ?? ''),
        gid: (row) => String(row?.info?.supp_item_id ?? ''),
        material: (row) => String(row?.info?.material ?? ''),
        mapMatchStatus: (row) => row?.uuid ? 'Сверено' : 'Не сверено',
        distance: (row) => String(row?.distance ?? ''),
        ext_field_1: (row) => String(row?.info?.ext_field_1 ?? ''),
        ext_field_2: (row) => String(row?.info?.ext_field_2 ?? ''),
        ext_field_3: (row) => String(row?.info?.ext_field_3 ?? ''),
        ext_field_4: (row) => String(row?.info?.ext_field_4 ?? ''),
        ext_field_5: (row) => String(row?.info?.ext_field_5 ?? ''),
        ext_field_6: (row) => String(row?.info?.ext_field_6 ?? ''),
        ext_field_7: (row) => String(row?.info?.ext_field_7 ?? ''),
        ext_field_8: (row) => String(row?.info?.ext_field_8 ?? ''),
        ext_field_9: (row) => String(row?.info?.ext_field_9 ?? ''),
        ext_field_10: (row) => String(row?.info?.ext_field_10 ?? ''),
        additional_field_1: (row) => String(row?.priceInfo?.additional_field_1 ?? ''),
        additional_field_2: (row) => String(row?.priceInfo?.additional_field_2 ?? ''),
        additional_field_3: (row) => String(row?.priceInfo?.additional_field_3 ?? ''),
        additional_field_4: (row) => String(row?.priceInfo?.additional_field_4 ?? ''),
        additional_field_5: (row) => String(row?.priceInfo?.additional_field_5 ?? ''),
        additional_field_6: (row) => String(row?.priceInfo?.additional_field_6 ?? '')
    };

    static async getTableSimilarSides(page = 0, priceId = '', contractNumbers = []) {
        return this._getTableSimilarSides(page, priceId, contractNumbers);
    }

    static async _getTableSimilarSides(page = 0, priceId = '', contractNumbers = []) {
        const { queryParams, requestBody } = this._getTableSimilarSidesBefore(page, priceId, contractNumbers);

        try {
            const res = await ServiceApi.post(this._microserviceName, this._requestRouts.getTableSimilarSides, requestBody, { params: queryParams });
            const tableData = this._getTableSimilarSidesAfter(res?.data?.data ?? {});

            return tableData;
        } catch (error) {
            console.log(error)
        }
    }

    static _getTableSimilarSidesBefore(page = 0, priceId = '', contractNumbers = []) {
        const queryParams = {
            'page': parseInt(page),
            'per-page': 20
        };

        const requestBody = {
            'transaction': String(priceId),
            'contract_numbers': contractNumbers.map(contractNumber => String(contractNumber))
        };

        return { queryParams, requestBody };
    }

    static _getTableSimilarSidesAfter(responseData = {}) {
        const rows = responseData?.items ?? [];
        const tableRows = rows.map(row => {
            const tableRow = Object.keys(this._tableRowToMatchScheme).reduce((tableRow, tableColumnKey) => {
                tableRow[tableColumnKey] = this._tableRowToMatchScheme[tableColumnKey](row);
                tableRow.extraData = { prices: [{ map_match_status: row?.uuid ? 1 : 2 }] };

                return tableRow;
            }, {});

            return tableRow;
        });

        const tableData = {
            pageCount: parseInt(responseData?.pageCount ?? 1),
            tableColumn: this._tableColumnsToMatchScheme,
            tableRows
        };

        return tableData;
    }

    static async runMatch(priceId = '', mapPriceId = '') {
        return this._runMatch(priceId, mapPriceId);
    }

    static async _runMatch(priceId = '', mapPriceId = '') {
        const requestBody = this._runMatchBefore(priceId, mapPriceId);

        try {
            await ServiceApi.post(this._microserviceName, this._requestRouts.runMatch, requestBody);

            return true;
        } catch (error) {
            console.log(error);
        }
    }

    static _runMatchBefore(priceId = '', mapPriceId = '') {
        const requestBody = { transaction: String(priceId), map_price_id: parseInt(mapPriceId) };

        return requestBody;
    }

    static async acceptDifference(fileId = '', sheetId = '', rowId = '', action = '', attribute = '', uuid = '') {
        return this._acceptDifference(fileId, sheetId, rowId, action, attribute, uuid);
    }

    static async _acceptDifference(fileId = '', sheetId = '', rowId = '', action = '', attribute = '', uuid = '') {
        const requestBody = this._acceptDifferenceBefore(fileId, sheetId, rowId, action, attribute, uuid);

        try {
            await ServiceApi.post(this._microserviceName, this._requestRouts.acceptDifference, requestBody);
        } catch (error) {
            console.log(error);
        }
    }

    static _acceptDifferenceBefore(fileId = '', sheetId = '', rowId = '', action = '', attribute = '', uuid = '') {
        const requestBody = {
            file_id: parseInt(fileId),
            sheet_index: parseInt(sheetId),
            row_index: parseInt(rowId),
            action: String(action),
            attribute: String(attribute),
            uuid: String(uuid)
        };

        return requestBody;
    }
}
